/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrafficCone = createReactComponent("traffic-cone", "IconTrafficCone", [
  ["path", { d: "M4 20l16 0", key: "svg-0" }],
  ["path", { d: "M9.4 10l5.2 0", key: "svg-1" }],
  ["path", { d: "M7.8 15l8.4 0", key: "svg-2" }],
  ["path", { d: "M6 20l5 -15h2l5 15", key: "svg-3" }]
]);

export { IconTrafficCone as default };
//# sourceMappingURL=IconTrafficCone.js.map
